const FIELD_SEPARATOR = '|';

const getIntervenerIdFromValue = value => {
    if (!value) {
        return {};
    }

    const [ personType, personCode ] = value.split(FIELD_SEPARATOR);

    return ({ personType, personCode });
};

const getValueFromIntervenerId = intervenerId => {
    if (!intervenerId || !intervenerId.personType || !intervenerId.personCode) {
        return undefined;
    }

    return `${intervenerId.personType}${FIELD_SEPARATOR}${intervenerId.personCode}`;
};

const isEmptyIntervenerId = intervenerId => {
    return !intervenerId || !intervenerId.personType || !intervenerId.personCode;
};

module.exports = {
    getIntervenerIdFromValue,
    getValueFromIntervenerId,
    isEmptyIntervenerId
};
